import React from "react";
import { Flex } from "@chakra-ui/react";
import { withTranslation } from "react-i18next";
import { Subtitle2 } from "src/atoms/typography/";
import Settings from "src/scenes/Settings";
import WhatsNew from "src/scenes/WhatsNew";
import PurchaseFlow from "src/modules/purchase/PurchaseFlow";
import LogoAvatar from "src/modules/avatar/components/LogoAvatar";
import PopoverView from "src/components/PopoverView";
import FullScreen from "src/atoms/FullScreen";
import { store } from "src/store/store";
import { lastRoleChanged } from "src/duck/actions";
import HistoryActivityLogFlow from "src/modules/activity-log/HistoryActivityLogFlow";

import OpenBabyStationButton from "./components/OpenBabyStationButton";
import OpenParentStationButton from "./components/OpenParentStationButton";
import NoPairedDevices from "./components/NoPairedDevices";
import Tabs from "./components/Tabs";
import updateWindowSize from "./updateWindowSize";
import compareWhatsNewContentVersion from "./compareWhatsNewContentVersion";

class Dashboard extends React.Component {
  state = {
    OpenedFlow: null,
    activityLogIsOpen: false,
    shouldRenderAcitivityLog: false,
    shouldRenderNoPairedDevices: false
  };
  componentDidMount = () => {
    const { onFirstimeEnter, wasInDashboardBefore, whatsNewContentVersion } = this.props;
    store.dispatch(lastRoleChanged(null));
    if (!wasInDashboardBefore) onFirstimeEnter();

    updateWindowSize();
    this.handleUnFinishedPurchase();

    const showWhatsNew = compareWhatsNewContentVersion(whatsNewContentVersion);
    if (showWhatsNew) this.openFlow(WhatsNew);
  };

  componentWillUnmount() {
    const { frame } = this.props;
    frame && frame.setDefaults();
  }

  handleUnFinishedPurchase() {
    const { hasPremium } = this.props;

    const activationData = localStorage.getItem("purchase.activationData");
    if (activationData) {
      if (hasPremium) {
        localStorage.removeItem("purchase.activationData");
        return;
      }
      this.openFlow(PurchaseFlow);
    }
  }

  openFlow = (Flow) => this.setState({ OpenedFlow: Flow });
  closeFlow = () => this.setState({ OpenedFlow: null });

  goToBabyStation = async () => {
    const { router, app, synchronizeCloudAccount, hasPairedDevices } = this.props;
    await synchronizeCloudAccount();
    if (!hasPairedDevices) {
      this.setState({ shouldRenderNoPairedDevices: true });
      return;
    }
    const hasPermission = await app.permissions.resolveMediaPermission("microphone");

    if (!hasPermission) {
      app.permissions.openDialog("microphone");
      return;
    }

    router.navigate("/baby-station");
  };
  goToParentStation = async (to) => {
    const { router, synchronizeCloudAccount, hasPairedDevices } = this.props;
    await synchronizeCloudAccount();
    if (!hasPairedDevices) {
      this.setState({ shouldRenderNoPairedDevices: true });
      return;
    }
    router.navigate("/parent-station");
  };

  closeActivityLog = () => this.setState({ activityLogIsOpen: false });
  closeNoPairedDevices = () => this.setState({ shouldRenderNoPairedDevices: false });

  openPairingWizard = () => {
    const { openWizard } = this.props;
    this.closeNoPairedDevices();
    openWizard();
  };

  render() {
    const { OpenedFlow, activityLogIsOpen, shouldRenderNoPairedDevices } = this.state;
    const { t, frame } = this.props;

    return (
      <>
        <PopoverView
          isOpen={Boolean(OpenedFlow)}
          onClose={this.closeFlow}
          modalProps={{ closeOnOverlayClick: false }}
          bodyProps={{ overflowX: "hidden" }}
        >
          {OpenedFlow && <OpenedFlow onClose={this.closeFlow} />}
        </PopoverView>

        <NoPairedDevices
          isOpen={shouldRenderNoPairedDevices}
          onClose={this.closeNoPairedDevices}
          onContinue={this.openPairingWizard}
        />
        <HistoryActivityLogFlow isOpen={activityLogIsOpen} onClose={this.closeActivityLog} />
        <FullScreen>
          <Flex flexDirection="column" justifyContent="center" alignItems="center" minHeight="100%">
            <Tabs
              openActivityLog={() => this.setState({ activityLogIsOpen: true })}
              openPremium={() => this.openFlow(PurchaseFlow)}
              openSettings={() => this.openFlow(Settings)}
            />
            <Flex
              flexDirection="column"
              justifyContent="center"
              alignItems="center"
              flex="1 1 auto"
              mb={frame ? ["48px", "72px"] : "0px"}
            >
              <LogoAvatar />
            </Flex>

            <Flex flexDirection="column" justifyContent="center" alignItems="center" pb="40px" flex="0 0 auto">
              <Subtitle2
                // fontSize={["12px", "14px", "16px"]}
                fontSize="clamp(1.2rem, 2.29vmin, 1.6rem)"
                color="mediumEmphasis"
              >
                {t("dashboard.useThisDeviceAs")}
              </Subtitle2>
              <OpenBabyStationButton
                // mt="8px"
                mt="1.5vmin"
                onClick={this.goToBabyStation}
              />
              <OpenParentStationButton
                // mt="16px"
                mt="1.5vmin"
                onClick={this.goToParentStation}
              />
            </Flex>
          </Flex>
        </FullScreen>
      </>
    );
  }
}

export default withTranslation()(Dashboard);
